module.exports = __webpack_public_path__ + "img/HelenaHolen.94c746d1.jpg";